import { css } from 'aphrodite';
import { Skeleton } from '../../../components-v2/Skeleton';
import { Avatar } from '@HoudiniUI/Avatar';
import { CallIcon } from '../../../components/svgs/icons/CallIcon';
import { EmailIcon } from '../../../components/svgs/icons/EmailIcon';
import { bs } from '../../../styles/styles';
import { s } from './styles';

interface ContactCardProps {
	firstName?: string;
	lastName?: string;
	email?: string;
	phone?: string;
	company?: string;
	profilePic?: string;
	onClick: () => void;
}

export function AssistantChatContactCard({
	firstName,
	lastName,
	email,
	phone,
	company,
	profilePic,
	onClick,
}: ContactCardProps) {
	return (
		<div className={css(s.contactCard)} onClick={onClick}>
			<div className={css(bs.flex, bs.itemsCenter, bs.gap3, bs.mb3)}>
				<Avatar
					imgSrc={profilePic}
					fallbackText={`${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`}
					styles={[s.avatar]}
					fallbackStyles={[s.avatar]}
				/>
				<div>
					<h3 className={css(bs.fontBold, bs.textBase, bs.textGray600, bs.m0, bs.breakAll)}>
						{firstName} {lastName}
					</h3>
					{company ? <span className={css(s.contactCardCompanyPill)}>{company}</span> : null}
				</div>
			</div>
			<div className={css(bs.flex, bs.flexCol, bs.gap2, bs.pl1, bs.textSm)}>
				{email ? (
					<div className={css(bs.flex, bs.itemsCenter, bs.gap2, bs.textGray600)}>
						<EmailIcon className={css(bs.w4, bs.h4, bs.flexShrink0)} fillColor='#9ca3af' />
						<span className={css(bs.breakAll)}>{email}</span>
					</div>
				) : null}
				{phone ? (
					<div className={css(bs.flex, bs.itemsCenter, bs.gap2, bs.textGray600)}>
						<CallIcon className={css(bs.w4, bs.h4, bs.flexShrink0)} fillColor='#9ca3af' />
						<span className={css(bs.breakAll)}>{phone}</span>
					</div>
				) : null}
			</div>
		</div>
	);
}

export function AssistantChatContactCardSkeleton() {
	return (
		<div className={css(s.contactCard)}>
			<div className={css(bs.flex, bs.itemsCenter, bs.gap2, bs.mb3)}>
				<Skeleton styles={[bs.w10, bs.h10, bs.roundedFull]} />
				<div className={css(bs.flex, bs.flexCol, bs.gap2, bs.flex1)}>
					<Skeleton styles={[bs.h6, bs.rounded2xl]} />
					<Skeleton styles={[bs.h4, bs.w16, bs.rounded2xl]} />
				</div>
			</div>
			<div className={css(bs.flex, bs.flexCol, bs.gap2, bs.pl1, bs.textSm)}>
				<Skeleton styles={[bs.wFull, bs.h4, bs.rounded2xl]} />
				<Skeleton styles={[bs.wFull, bs.h4, bs.rounded2xl]} />
			</div>
		</div>
	);
}
